export default "__VITE_ASSET__DIp_yYir__"